import { validateBusinessName, validateCuilCuit, validateEmail, validateInputText, validatePhone } from "common/ClienteFieldValidator.utils"
import { isArgentinaPhoneCode } from 'common/phone/phoneUtils'

export const TYPES = {
  FISICA: 'HUMANA',
  JURIDICA: 'JURIDICA'
}

export const LOWERCASE_PERSON_TYPES = {
  FISICA: 'Física',
  JURIDICA: 'Jurídica'
}

export const LEAD_MODULES = {
  HISTORIES: 'histories',
  FILES: 'files',
  TASKS: 'tasks',
  NOTES: 'notes',
  PUBLICATIONS: 'publications',
  TEST_DRIVES: 'testDrives',
}

export const MODAL_MODE = {
  EDIT: 'EDIT',
  CREATE: 'CREATE'
}

export const LEAD_TASK_STATE = {
  finalizada: 'FINALIZADA',
  descartada: 'DESCARTADA',
  pendiente: 'PENDIENTE',
}

export const LEAD_STATE = {
  UNASSIGNED: {
    key: 'unassigned',
    label: 'No asignado',
    labelAlt: 'Sin asignar'
  },
  ASSIGNED: {
    key: "assigned",
    label: 'Asignado',
  },
  MANAGING: {
    key: "managing",
    label: 'Gestionando',
  },
  NEGOTIATING: {
    key: "negotiating",
    label: 'Negociando',
  },
  CLOSED_SUCCESS: {
    key: "closedSuccessfull",
    label: 'Cierre exitoso',
  },
  CLOSED_FAIL: {
    key: "closedLost",
    label: 'Cierre perdido',
  },
}

export const LEADS_TYPE_HISTORIES = {
  //CHANGE STATE
  leadEntry: {
    KEY: 'leadEntry',
    label: 'Ingreso de lead desde ',
    secondLabel: 'Asignó este lead a ',
    thirdLabel: 'La gestión será supervisada por '
  },
  assignedLead: {
    KEY: 'assignedLead',
    label: 'Asignó este lead a ',
    secondLabel: 'La gestión será supervisada por '
  },
  reassignedLead: {
    KEY: 'reassignedLead',
    label: 'Reasignó este lead a ',
    secondLabel: 'La gestión será supervisada por '
  },
  assignedAutomaticLead: {
    KEY: 'assignedAutomaticLead',
    label: 'Se asignó este lead a ',
    secondLabel: 'La gestión será supervisada por '
  },
  reassignedAutomaticLead:{
    KEY: 'reassignedAutomaticLead',
    label: 'Se reasignó este lead a ',
    labelExtra: ' por falta de gestión.',
    secondLabel:'La gestión será supervisada por '
  },
  supervisionChange: {
    label: 'Actualizó quién supervisará la gestión: '
  },
  startManagement: {
    label: 'Inició la gestión de este lead'
  },
  answerMeliQuerie: {
    label: 'Respondió la consulta de '
  },
  startManagementMeli: {
    label: 'Respondió una consulta de ',
    secondLabel: 'Se creó la tarea ',
    thirdLabel: 'Se inició la gestión de este lead.',
  },
  changeBusinessUnit:{
    KEY: 'changeBusinessUnit',
    label: 'Cambió el tipo de negocio: de '
  },
  generateDocument:{
    label: 'Generó el '
  },
  requestExpertise: {
    label: 'Solicitó un peritaje.'
  },
  startNegotiation: {
    label: 'Inició la negociación'
  },
  closeProcessReason: {
    label: ''
  },
  closeProcess: {
    label: 'Cerró el proceso.'
  },
  carEntry: {
    label: 'Ingresó el vehículo a la empresa. Se cerró el proceso.'
  },
  closeSucess: {
    label: 'Cerró exitosamente el proceso.'
  },
  carExpertiseFinish: {
    label: 'El vehículo está por ingresar a la empresa. Se cerró el proceso.'
  },
  closeSucessToNegotiating: {
  },
  //TASKS
  createTask: {
    label: 'Creó la tarea ',
    secondLabel: 'Fecha y hora de ejecución '
  },
  editTitleTask: {
    label: 'Editó el título de la tarea '
  },
  editTask: {
    label: 'Editó/Agregó detalles en la tarea '
  },
  finishTask: {
    label: 'Finalizó la tarea '
  },
  deleteTask: {
    label: 'Eliminó la tarea '
  },
  noFinishedTasks: {
    label: 'Se descartaron tareas sin finalizar de '
  },
  //NOTE
  createNote: {
    label: 'Escribió una '
  },
  //EDIT
  editLead: {
    label: 'Editó la información del lead.'
  },
  changeHolderLead: {
    label: 'Cambió la titularidad de la oportunidad.'
  },
  // LEAD LINKS
  linkLead: {
    KEY: 'linkLead',
    label: 'Atendió a este lead y lo asoció a esta oportunidad.'
  },
  newInterest: {
    KEY: 'newInterest'
  },
  contactLead: {
    KEY: 'contactLead',
    label: 'Contactó al lead por '
  },
  quotationLead: {
    label: 'Generó la'
  },
  accessCatalog: {
    label: 'Accedió a',
  },
  createTestDrive: {
    KEY: 'createTestDrive'
  },
  createImages: {
    KEY: 'createImages'
  },
  createAttachmentsFromChatbot: {
    KEY: 'createAttachmentsFromChatbot',
    label: 'Asistente virtual',
    secondLabel: 'Cargó un archivo',
  },
}

export const LEADS_ROLES = {
  admin: 'admin',
  supervisor: 'supervisor',
  commercialAdvisor: 'commercialAdvisor',
}

export const LEADS_ROLES_NAMES = {
  administrator: 'Administrador',
  supervisor: 'Supervisor',
  commercialAdvisor: 'Asesor comercial',
}

export const LEADS_ROLES_ACRONYMS = {
  admin: 'GDL_A',
  supervisor: 'GDL_S',
  commercialAdvisor: 'GDL_CA',
}

export const LEADS_DISTRIBUTIONS = {
  shark_pool: 'shark_pool',
}

export const validateField = (field, value, context = {}) =>{
  const FUNCTION_PER_FIELD = {
    name: validateInputText(value),
    lastname: validateInputText(value),
    phone: validatePhone(value, {
      skipMaxLength: true,
      skipMinLength: !isArgentinaPhoneCode(context.phoneCountryCode),
    }),
    email: validateEmail(value),
    CUIT: validateCuilCuit(String(value),TYPES.FISICA,TYPES.JURIDICA),
    businessName: validateBusinessName(value),
  }
  return FUNCTION_PER_FIELD[field]
}

export const validateFormCompletion = (errors, personType, lead) => {
  if(
    //These are appliable to both a physical or a legal person
    (!lead.name ||
    !lead.lastname ||
    !lead.phone ||
    !lead.email) ||
    //These are just appliable to a legal person
    (personType === TYPES.JURIDICA
      &&
     (
       !lead.CUIT
     ))
  ) return false

  return Object.keys(errors).length === 0;
}

export const validateInterestData = cell => {
  return cell ? (cell.trim() === '') ? '-' : cell.toUpperCase() : '-'
}

export const ORIGIN_OPTIONS_ENUM = {
  FACEBOOK: 'Facebook',
  INSTAGRAM: 'Instagram',
  LLAMADA_ENTRANTE: 'Llamada Entrante',
  MERCADO_LIBRE: 'Mercado Libre',
  VISITA_SALON: 'Visita Salón',
  WHATSAPP_ENTRANTE: 'Whatsapp Entrante'
}

export const ORIGIN_OPTIONS = Object.values(ORIGIN_OPTIONS_ENUM).map(v => ({ value: v, label: v })) // Revisar uso ID-94191 


// TODO -> obtener desde la bd y mantener en redux para evitar multiples llamados
export const BUSINESS_UNIT_OPTIONS = [
  {value: '0km', label: '0km'},
  {value: 'Usado', label: 'Usado'},
  {value: 'Plan de Ahorro', label: 'Plan de Ahorro'},
  {value: 'Ventas Especiales', label: 'Ventas Especiales'},
  {value: 'Compra de Usado', label: 'Compra de Usado'},
  {value: 'Posventa', label: 'Posventa'},
  {value: 'Otros', label: 'Otros'},
]

export const BUSSINESS_UNITS = {
  '0KM': '0km',
  USADO: 'Usado',
  COMPRA_DE_USADO: 'Compra de Usado',
  PLAN_DE_AHORRO: 'Plan de Ahorro',
  VENTAS_ESPECIALES: 'Ventas Especiales',
  POSVENTA: "Posventa",
  OTROS: "Otros"
}

export const REQUIRED_OPPORTUNITY_DATA = [
  'origin',
  'businessUnit',
  'brandId',
  'modelId'
]

export const FILTER_HISTORY_DAYS = {
  LAST_SEVEN_DAYS: {value: 7, label: 'Últimos 7 días'},
  LAST_FIFTEEN_DAYS: {value: 15, label: 'Últimos 15 días'},
  LAST_THIRTY_DAYS: {value: 30, label: 'Últimos 30 días'},
  ALL_DAYS: {value: 'all', label: 'Toda la actividad'},
}

export const MAX_FILE_ROWS = '5000'

export const TITLE_ATTACH_FILE = 'Adjuntá tu archivo'

export const SUBTITLE_ATTACH_FILE = `El archivo debe ser en formato .xlsx y tener ${MAX_FILE_ROWS} filas como máximo.`

export const TITLE_TEMPLATE = 'Plantilla para carga masiva'

export const SUBTITLE_TEMPLATE = 'Esta plantilla tiene todos los datos necesarios para crear tus leads. Es importante que no la modifiques.'

export const TITLE_ADDING_FILE = 'Estamos subiendo el archivo'

export const SUBTITLE_ADDING_FILE = 'Puede demorar unos minutos'
